// src/app/features/setup/tenant-resolver.ts
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { TenantConfig } from './core/models/TenantConfig.model';
import { TenantService } from './core/services/tenant.service';

@Injectable({
  providedIn: 'root',
})
export class TenantResolver implements Resolve<TenantConfig> {
  constructor(private tenantService: TenantService) {}

  // Note: Resolve<T> can return Promise<T>
  resolve(): Promise<TenantConfig> {
    return this.tenantService.loadTenantConfig();
  }
}
